import { getCircleRadians } from "./getCircleRadians";

export function getCircleDetails(sI: number, radians: number[], radius: number, isbtw: boolean) { //sI = SltdPIndex
  const rL = radians.length;
  const endRadian = radians[sI != 0 ? sI - 1 : rL - 1];
  const middleRadian = radians[sI];
  const startRadian = radians[sI != rL - 1 ? sI + 1 : 0];
  const _radians = [endRadian, middleRadian, startRadian];
  const Radians = getCircleRadians(_radians, isbtw);
  const details = {
    radians: Radians,
    radius
  }

  return details
}